import React from "react";
import { Link } from "react-router-dom";
import { toLower, startCase } from "lodash";
import { Tooltip } from "../../../core";
import RouteAllowed from "../../../helper/isRouteAllowed";

export function columns(
  toggleAcceptModal,
  toggleDeleteUnAcceptedDeviceModal,
  permission,
  roles
) {
  return [
    {
      dataField: "mac_address",
      text: "Mac Address",
      columnName: "name"
    },
    {
      dataField: "actionButtons",
      text: "",
      columnName: "isSelected",
      style: { position: "relative" },
      formatter: (name, row) => (
        <div className="d-flex">
          <div className="contentSectionTable__menu">
            <i className="fas fa-ellipsis-h" />
          </div>
          <div className="contentSectionTable__actionButtonWrapper">
            <RouteAllowed
              roles={roles && roles}
              permission={permission && permission.devices.delete}
            >
              <span className="contentSectionTable__actionButtonWrapper__buttons">
                <Tooltip
                  item={
                    <i
                      role="presentation"
                      onClick={e =>
                        toggleDeleteUnAcceptedDeviceModal(row.mac_address)
                      }
                      className="fa fa-trash"
                    />
                  }
                  id={`delete-${row.id}`}
                  tooltipContent="Delete"
                />
              </span>
            </RouteAllowed>
            .
          </div>
        </div>
      )
    }
  ];
}
